import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { LanguageIcon } from "@heroicons/react/24/solid";
import { useLanguage } from "../context/languageContext";

export default function LanguageSelector() {
  const { setLanguage } = useLanguage();

  return (
    <Menu as="div" className="fixed z-50 top-5 right-5 bg-strata-blue rounded-full p-2 text-white hover:bg-blue-800 cursor-pointer">
      <MenuButton className="flex justify-center items-center">
        <LanguageIcon className="h-7 w-7" />
      </MenuButton>

      <MenuItems
        transition
        className="absolute right-0 z-10 mt-2 w-32 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
      >
        <div className="py-1">
          <MenuItem>
            <div onClick={() => setLanguage("en")} className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900">
              English
            </div>
          </MenuItem>
          <MenuItem>
            <div onClick={() => setLanguage("es")} className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900">
              Español
            </div>
          </MenuItem>
        </div>
      </MenuItems>
    </Menu>
  );
}
